module.exports = __webpack_public_path__ + "img/ANYMARKET_LOGO.90aeb059.png";